import initializingSmartScript from './initializingSmartScript.js';
import { staticLink } from './constants.js';

export default function setAppLink(data) {
    if (!data) {
        return null;
    }

    const mobileAppLinkIos = data.mobile_app_link_ios;
    const mobileAppLinkAndroid = data.mobile_app_link_android;
    let link = mobileAppLinkIos || mobileAppLinkAndroid || staticLink;

    if (!link) {
        console.error('Отсутствует ссылка для QR');
        return null;
    }
    
    const result = initializingSmartScript(link);
    let result_url = "No output from script";

    if (result) {
        result_url = result.clickURL;     
        const buttons = document.querySelectorAll(".js-button-download");

        buttons.forEach(button => {
            button.setAttribute('href', result_url);
        });
    } 
}


// WEBPACK FOOTER //
// ./_layout/js/setAppLink.js